import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const successStoriesData: NavItem[] = [
  {
    label: 'Hero',
    to: '/pages/successStories/hero'
  },
  {
    label: 'Vision-top',
    to: '/pages/successStories/visionTop'
  },
  {
    label: 'Vision-bottom',
    to: '/pages/successStories/visionBottom'
  },
  {
    label: 'Report',
    to: '/pages/successStories/report'
  },
  {
    label: 'Teams',
    to: '/pages/successStories/teams'
  }
];
